import { fetchData } from '@/services/fetchData';
import { setCreatedNFTs, setOnSaleNFTs, setOwnedNFTs } from '@/store/app';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

export const useUpdateUserNFTs = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const fetchNFTData = async (address) => {
    const owned = await fetchData({
      url: `/nfts?owner=${address}`,
    });
    const created = await fetchData({
      url: `/nfts?creator=${address}`,
    });
    const onSale = await fetchData({
      url: `/nfts?owner=${address}&listed=true`,
    });

    dispatch(setOwnedNFTs(owned));
    dispatch(setCreatedNFTs(created));
    dispatch(setOnSaleNFTs(onSale));
  };

  const getNFTs = async (address) => {
    await fetchNFTData(address)
      .finally(() => setLoading(false))
      .catch(() => null);
  };

  return { loading, getNFTs };
};
